<mat-dialog-content>
  <img [src]="data.base64 ? (data.url | base64ToImage) : (data.url | secure | async)" />
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button class="cancel-button" mat-dialog-close>
    {{ 'SHARED.DIALOGS.IMAGE_DIALOG.CLOSE' | translate }}
  </button>
</mat-dialog-actions>
